// extracted by mini-css-extract-plugin
export var brand = "_8x-9";
export var compact = "_8x-6";
export var extraSmall = "_8x-7";
export var icon = "_8x-0";
export var large = "_8x-4";
export var light = "_8x-1";
export var medium = "_8x-5";
export var outline = "_8x-b";
export var primaryDark = "_8x-a";
export var primaryLight = "_8x-8";
export var primaryModern = "_8x-c";
export var success = "_8x-2";
export var successSolid = "_8x-3";